import styled from "@emotion/styled";
import { Omit } from "utility-types";
import { IconCommonProps } from "./IconCommonProps";

interface IconStyledProps extends Omit<IconCommonProps, "dangerouslySetSvg" | "height" | "width"> {
    height: string;
    width: string;
}

export const IconStyled = styled("span", {
    shouldForwardProp: (propName) => {
        switch (propName) {
            // These are a little confusing to see in the HTML and the CSS so let's filter them out
            // since they don't do anything here as HTML attributes.
            case "height":
            case "width":
            case "color":
            case "svgCss":
            case "cssCustomProperties":
                return false;
            default:
                return true;
        }
    },
})<IconStyledProps>(
    ({ color, height, width, cssCustomProperties }) => ({
        display: height === "auto" || width === "auto" ? "inline-block" : "flex",
        lineHeight: height === "auto" || width === "auto" ? 0 : "inherit",
        flexShrink: 0,
        color,
        height: `var(--sds--ursa-icons--height, var(--sds--ursa-icons--size, ${height}))`,
        width: `var(--sds--ursa-icons--width, var(--sds--ursa-icons--size, ${width}))`,
        ...cssCustomProperties,
    }),
    ({ svgCss = {} }) => ({
        "> svg": {
            overflow: "hidden",
            pointerEvents: "none",
            verticalAlign: "bottom",

            // We're intentionally add this spread here since we control the following props more carefully.
            ...(svgCss as Record<string, unknown>),

            height: "100%",
            width: "100%",
        },
    })
);

IconStyled.displayName = "IconWrapper";
